'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { zodResolver } from '@hookform/resolvers/zod'
import { useLatestRef } from '@qogita/react-hooks/use-latest-ref'
import { Anchor } from '@qogita/ui/v2/anchor'
import { Button, ButtonLoader } from '@qogita/ui/v2/button'
import {
  FormControl,
  FormFieldController,
  FormItem,
  FormLabel,
  FormMessage,
  FormProvider,
} from '@qogita/ui/v2/form'
import { Input } from '@qogita/ui/v2/input'
import {
  PasswordFieldInput,
  PasswordFieldRoot,
} from '@qogita/ui/v2/password-field'
import { startTransition, useActionState } from 'react'
import { useForm } from 'react-hook-form'
import { FormRootErrorMessage } from 'src/components/form-root-error-message'
import { browserLogger } from 'src/core/logger/browser'

import { type LoginSchema, loginSchema } from '../_lib/login-schema'
import { applyFieldErrors } from 'src/lib/apply-field-errors'

export function LoginForm({
  submitAction,
  defaultValues,
}: {
  submitAction: (formData: FormData) => Promise<{
    status: 'error'
    errors: Partial<
      Record<keyof LoginSchema | 'root', { type: string; message: string }>
    >
  }>
  defaultValues?: Partial<LoginSchema>
}) {
  const form = useForm({
    mode: 'onBlur',
    defaultValues: { email: '', password: '', ...defaultValues },
    resolver: zodResolver(loginSchema),
  })
  const latestFormErrorsRef = useLatestRef(form.formState.errors)

  const [, formAction, isPending] = useActionState(
    async (_previous: unknown, formData: FormData) => {
      // oxlint-disable-next-line react-hooks/immutability -- TODO: fix this genuine linter error if you are working on this code.
      if (isPending) return

      const isValid = await form.trigger()
      if (!isValid) {
        browserLogger.warn('Client side form validation failed', {
          // Deliberately not using structured clone here as the RHF errors object includes a bunch of non-serializable stuff we don't care about logging
          // oxlint-disable-next-line unicorn/prefer-structured-clone
          validationErrors: JSON.parse(
            JSON.stringify(latestFormErrorsRef.current),
          ),
        })
        return null
      }

      const result = await submitAction(formData)

      startTransition(() => {
        if (result && result.status === 'error') {
          applyFieldErrors(form.setError, result.errors)
        }
      })
    },
    null,
  )

  return (
    <FormProvider {...form}>
      <form action={formAction} className="flex w-full flex-col gap-3">
        <FormFieldController
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email address</FormLabel>
              <FormControl>
                <Input {...field} type="email" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormFieldController
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Password</FormLabel>
              <PasswordFieldRoot>
                <FormControl>
                  <PasswordFieldInput {...field} />
                </FormControl>
              </PasswordFieldRoot>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex flex-col gap-3">
          <Anchor
            href="https://www.qogita.com/reset-password/"
            className="self-end"
            variant="text"
          >
            Forgot password?
          </Anchor>

          <FormRootErrorMessage />

          <Button variant="contained" type="submit">
            <ButtonLoader>Login</ButtonLoader>
          </Button>
        </div>
      </form>
    </FormProvider>
  )
}
